export default {
  nav: {
    onlineSms: 'Online SMS',
    rentNumber: 'Software Dev',
    esim: 'Lottery',
    apiConnection: 'API',
    agent: 'Live Chat',
    blog: 'Share',
    help: 'Help',
    register: 'Register',
    login: 'Login'
  },
  header: {
    memberCenter: 'Member Center',
    logout: 'Logout',
    logoutSuccess: 'Logged out successfully'
  },
  common: {
    user: 'User',
    chinese: 'Chinese',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    submit: 'Submit',
    search: 'Search',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    networkError: 'Network error, please try again later',
    payWith: 'Pay with',
    unit: '',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    more: 'More',
    next: 'Next',
    prev: 'Previous'
  },
  home: {
    title: 'SMS Receiving Platform',
    subtitle: 'Register on social networks, online stores, exchanges and online services without receiving spam or exposing personal data.',
    btnGetNumber: 'Get Number',
    btnRent: 'Rent',
    phoneCount: '1000+',
    sectionTitle: 'SMS-MAN — Rent phone numbers to receive SMS',
    sectionDesc: 'With the help of SMS-MAN you can rent a virtual number to receive SMS from 200+ countries. Rental period: 24 hours, a week or a month. You can rent a number and receive unlimited SMS during the selected rental period.',
    sectionDesc2: 'It is very convenient when you need to register many online applications with a specified phone number. If the number does not suit you (if you did not receive any SMS), you can cancel it for free within 20 minutes!',
    howItWorks: 'See how it works',
    stepsTitle: 'Rent a virtual number online in 3 steps',
    step1Title: 'Choose your country',
    step2Title: 'Set rental period',
    step3Title: 'Rent a number',
    step1Desc: 'India, Mexico, Israel',
    step2Desc: 'Hour, Day, Week, Month',
    step3Desc: 'Rental period',
    whyChoose: 'Why choose SMS-MAN',
    feature1Title: 'You can buy a one-time phone number, or rent a number for up to a month',
    feature2Title: 'One-time number for receiving SMS',
    feature2Desc: 'Select a service or all services when ordering to receive SMS through a virtual number. Receive one-time SMS verification codes from any website or application.',
    feature3Title: 'Rent a number',
    feature3Desc: 'Rent a phone number and receive unlimited SMS from any website or application.',
    usageLimit: 'Usage limit',
    usageLimitDesc: 'Up to 20 minutes',
    usageLimitDesc2: 'Up to 30 days',
    youCanReceive: 'You can receive SMS',
    youCanReceiveDesc: 'From one website/app selected at checkout Unlimited',
    youCanReceiveDesc2: 'All available services',
    serviceCount: '200+',
    serviceCount2: '16',
    countryCount: '1000+',
    countryCount2: 'All available services',
    btnRentNow: 'Rent Now',
    btnRentNumber: 'Rent Number',
    aboutText: '"SMS-Man" allows you to create a virtual number to receive SMS. Rented numbers work on almost all platforms that require a phone number for registration.',
    aboutText2: 'Many websites require SMS verification. These services are usually not available with overseas phone numbers. Buying a SIM card for registration purposes is both troublesome and expensive. Just pay about $0.5-1 once.',
    aboutText3: 'SMS-MAN provides services in over 200 countries/regions. You can rent virtual numbers to receive SMS from any website or application.',
    aboutText4: 'There are many benefits to renting numbers on "SMS-Man":',
    aboutText5: 'One virtual number can be used to register on 200+ websites and applications.',
    aboutText6: 'You don\'t have to worry about exposing your personal phone number and receiving spam.',
    aboutText7: 'Manage numbers from different countries and receive SMS on one platform.',
    aboutText8: 'You don\'t need professional skills to use numbers, and the price is very cheap.',
    aboutText9: 'You can rent a phone number online anytime, anywhere!',
    registerTitle: 'Register',
    registerDesc: 'You don\'t need to enter personal information, just 3 steps',
    regStep1: 'Enter your email on the website',
    regStep1Desc: 'Enter your email address and create a password.',
    regStep2: 'Confirm your email in your mailbox',
    regStep2Desc: 'We have sent a confirmation email to the email you entered. Please open the email and click the confirmation link.',
    regStep3: 'Congratulations! You are registered',
    regStep3Desc: 'You can now log in and use all SMS-MAN services.',
    onlineServiceTitle: 'Convenient online SMS receiving service for you',
    joinTelegram: 'Join our online chat',
    joinTelegramDesc: 'Join our Telegram group for the latest news',
    telegramBot: 'Telegram bot',
    telegramBotDesc: 'Use Telegram Bot to receive SMS',
    userGroup: 'User group',
    userGroupDesc: 'Join user group for help',
    desktopApp: 'Desktop application',
    desktopAppDesc: 'Download desktop application',
    btnJoin: 'Join',
    btnConnect: 'Connect',
    btnDownload: 'Download',
    professionalTitle: 'Solution for professionals',
    professionalDesc: 'SMS-MAN not only provides convenient tools for ordinary users, but also for professionals who need to register a large number of accounts and access restricted resources.',
    apiConnect: 'Connect via API',
    apiConnectDesc: 'Batch receive and send SMS, automate your work',
    readMore: 'Read more',
    faqTitle: 'FAQ',
    faq1: 'What is the SMS platform service? How does it work?',
    faq2: 'What is SMS-MAN?',
    faq3: 'Do I need a one-time SIM card to receive SMS?',
    faq4: 'Is private information safe with SMS-MAN?',
    faq5: 'How to confirm SMS reception success?',
    faq6: 'Is the SMS platform really safe?',
    faq7: 'Why choose SMS-Man to receive SMS?',
    footer: {
      smsPlatform: 'SMS Platform',
      rentNumber: 'Rent Number',
      apiConnection: 'API',
      referral: 'Referral',
      partnership: 'Partnership',
      partners: 'Partners',
      blog: 'Share',
      help: 'Help',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      paymentRefund: 'Payment & Refund',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    emailPlaceholder: 'Enter email',
    passwordPlaceholder: 'Enter password',
    forgotPassword: 'Forgot password?',
    noAccount: 'Don\'t have an account?',
    register: 'Register',
    socialLogin: 'Or login with your social platform',
    btnLogin: 'Login',
    captchaSuccess: 'Success!',
    loginFailed: 'Login failed'
  },
  register: {
      title: 'Register',
      email: 'Enter email',
      codePlaceholder: 'Enter verification code',
      sendCode: 'Get Code',
      sending: 'Sending...',
      codeSent: 'Code sent, please check your email',
      password: 'Create password',
      confirmPassword: 'Confirm password',
      agreeTerms: 'By registering, you agree to',
      terms: 'Terms of Use',
      hasAccount: 'Already have an account?',
      login: 'Login',
      socialLogin: 'Or login with your social account',
      btnRegister: 'Register',
      registering: 'Registering...',
      captchaSuccess: 'Success!',
      passwordMismatch: 'Passwords do not match',
      registerFailed: 'Registration failed',
      codeExpired: 'Code expired, please request again',
      codeError: 'Invalid verification code'
    },
  member: {
    sidebar: {
      receiveSms: 'Receive SMS',
      premiumSms: 'Premium SMS',
      rentNumber: 'Rent Number',
      esim: 'eSIM',
      proxyMan: 'Proxy Man',
      recharge: 'Recharge',
      loyalty: 'Loyalty Program',
      earn: 'Earn',
      partnership: 'Partnership',
      api: 'API',
      instructions: 'Instructions',
      feedback: 'Feedback',
      help: 'Help',
      chatGroup: 'Live Chat',
      chatManage: 'Chat Manager',
      receptionRecords: 'Reception Records',
      chatPlan: 'Chat Plan',
	  chatSettings: 'Chat Settings',
      lotteryGroup: 'Lottery',
      lotteryBets: 'Betting Records'
    },
    header: {
      desktopClient: 'Desktop Client',
      desktopClientDesc: 'Receive SMS directly on your computer',
      telegramBot: 'Telegram Bot',
      telegramBotDesc: 'Receive SMS directly on Telegram',
      try: 'Try',
      connect: 'Connect',
      balance: 'Balance',
      recharge: 'Recharge',
      language: 'Language'
    },
    avatarMenu: {
      settings: 'Settings',
      profile: 'View Profile',
      logout: 'Logout'
    },
    receiveSms: {
      title: 'Receive SMS',
      selectService: 'Select a service',
      searchService: 'Search by service',
      selectCountry: 'Select your country',
      searchCountry: 'Search by country',
      sort: 'Sort',
      buySms: 'Buy SMS',
      doubleSms: 'Double SMS',
      btnBuySms: 'Buy SMS'
    },
    premiumSms: {
      title: 'Premium SMS',
      selectService: 'Select a service',
      searchService: 'Search by service',
      selectCountry: 'Select your country',
      searchCountry: 'Search by country',
      sort: 'Sort',
      buySms: 'Buy SMS',
      doubleSms: 'Double SMS',
      btnBuySms: 'Buy SMS'
    },
    rentNumber: {
      title: 'Rent Number',
      subtitle: 'Only for receiving SMS',
      wholeNumber: 'Whole Number',
      byService: 'By Service',
      selectCountry: '1. Select Country',
      search: 'Search',
      setDuration: '2. Set Duration',
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      rentNumber: '3. Rent Number',
      cost: 'Cost',
      btnRent: 'Rent',
      rentDesc: 'You pay for the number and its rental period. During the selected period, you can receive unlimited SMS. No cancellation, refund or early termination after purchase.',
      premiumTitle: 'Premium Number',
      premiumDesc: 'Access high-quality numbers with higher delivery rates and stronger reliability for SMS verification',
      btnPremium: 'Get Premium'
    },
    esim: {
      title: 'eSIM',
      selectCountry: '1. Select Country / Region',
      searchCountry: 'Search country or region',
      all: 'All',
      mixed: 'Mixed',
      showAll: 'Show all',
      selectPlan: '2. Select Plan',
      esimInfo: 'eSIM is activated immediately after payment. Installation QR code will be provided in your account.',
      phoneSupport: 'Does your phone support eSIM?',
      phoneSupportDesc: 'Dial *#06#, if EID is displayed, the device supports eSIM.',
      howToConfig: 'How to configure mobile data via eSIM',
      selectType: '3. Select eSIM Type',
      allType: 'All',
      dataOnly: 'Data Only',
      dataAndCall: 'Data + Calls',
      btnRecharge: 'Recharge'
    },
    recharge: {
      title: 'Recharge Balance',
      payMethod: 'Payment Method',
      usdtDesc: 'Recharge via USDT TRC-20 transfer, credited after admin confirmation',
      onlyUsdt: 'USDT Only',
      fillAmount: 'Recharge Amount',
      otherAmount: 'Custom amount',
      btnPay: 'Recharge Now',
      submitting: 'Submitting...',
      payDesc: 'USDT address and QR code will be shown after creating order',
      invalidAmount: 'Please enter a valid amount (min $1)',
      rechargeFailed: 'Recharge failed',
      rechargeFailedRetry: 'Recharge failed, please try again',
      historyTitle: 'Recharge History',
      thOrderNo: 'Order No.',
      thAmount: 'Amount',
      thStatus: 'Status',
      thTime: 'Time',
      statusPending: 'Pending',
      statusPaid: 'Credited',
      statusCancelled: 'Cancelled',
      scanToPay: 'Scan to Pay',
      payAmount: 'Amount',
      usdtAddress: 'USDT TRC-20 Address',
      copy: 'Copy',
      copied: 'Copied',
      orderNo: 'Order No.',
      waitingConfirm: 'Waiting for admin confirmation, will auto-refresh after payment',
      paySuccess: 'Recharge Credited',
      paySuccessDesc: 'Your recharge has been successfully credited'
    },
    feedback: {
      title: 'Contact Us',
      name: 'Your name',
      email: 'Email',
      question: 'Your question',
      btnSend: 'Send',
      captchaSuccess: 'Success!',
      support247: 'Support 24/7 online',
      responseTime: 'Average response time about 15 minutes',
      weekendWork: 'Weekend support works as usual',
      chatSupport: 'Chat Support',
      youtube: 'Our YouTube'
    },
    partnership: {
      title: 'Earn money with SIM cards on reliable services',
      desc1: 'If you have phone numbers (SIM cards) that can be used to receive SMS - this page is for you.',
      desc2: 'Start earning with SIM cards on SMS-Man!',
      whatTogether: 'What can we do together?',
      whatTogetherDesc: 'SMS-Man is an international platform for online SMS reception. We currently have 200,000 active users with over 100 million SMS requests per day.',
      whatTogetherDesc2: 'And that\'s not the most: our customers\' demands are growing rapidly. That\'s why we are looking for you.',
      howContact: 'How to contact SMS-Man?',
      restApi: 'REST API',
      restApiDesc: 'You provide us with API files and a direct payment account. We integrate it into our system.',
      gsmGoip: 'GSM/GoIP',
      gsmGoipDesc1: 'You have GSM/GoIP equipment',
      gsmGoipDesc2: 'We use special software to connect you to our system',
      gsmGoipDesc3: 'You will be able to track statistics on a dedicated dashboard',
      gsmGoipDesc4: 'Income depends on the country of the SIM card',
      apiLink: 'API Link',
      apiLinkDesc1: 'For example, you have numbers in this format:',
      apiLinkDesc2: 'We buy numbers according to the terms'
    },
    instructions: {
      title: 'Register Facebook via SMS-MAN',
      step1: 'Step 1. Get a number.',
      step1Desc: 'For this, use a one-time',
      receiveSms: 'Receive SMS',
      or: 'or',
      rentNumber: 'Rent Number',
      step2: 'Step 2: Copy the number you received.',
      step2Desc: 'Click the icon next to it or select the number, press Ctrl+C to copy.',
      step3: 'Step 3. Fill in Facebook registration info.',
      step3Desc: 'Go to facebook.com, click "Create New Account".'
    },
    loyalty: { title: 'Loyalty Program' },
    earn: { title: 'Earn' },
    api: { title: 'API Documentation' },
    help: { title: 'Help Center' },
    lotteryBets: {
      title: 'Betting Records',
      allTypes: 'All Types',
      allResults: 'All Results',
      win: 'Win',
      lose: 'Lose',
      pending: 'Pending',
      searchPeriod: 'Search period...',
      totalBets: 'Total Bets',
      totalWin: 'Win',
      totalLose: 'Lose',
      totalPending: 'Pending',
      totalProfit: 'Total P/L',
      period: 'Period',
      lotteryType: 'Type',
      playType: 'Play',
      betContent: 'Bet Content',
      betAmount: 'Amount',
      odds: 'Odds',
      drawNumbers: 'Draw Numbers',
      result: 'Result',
      profit: 'P/L',
      time: 'Time',
      totalRecords: '{0} records',
      prevPage: 'Previous',
      nextPage: 'Next'
    },
    profile: {
      title: 'Profile',
      pageDesc: 'View your account details',
      userId: 'User ID',
      balance: 'Balance',
      registerTime: 'Registration Time',
      lastLogin: 'Last Login',
      accountStatus: 'Account Status',
      langSetting: 'Language',
      statusActive: 'Active',
      statusInactive: 'Disabled',
      apiInfo: 'API Info',
      apiKey: 'API Key',
      notGenerated: 'Not generated',
      copy: 'Copy',
      usageStats: 'Usage Stats',
      smsOrders: 'SMS Orders',
      rechargeCount: 'Recharges',
      totalSpent: 'Total Spent',
      chatSessions: 'Chat Sessions'
    },
    settings: {
      title: 'Settings',
      pageDesc: 'Manage your account and security settings',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      currentPasswordPh: 'Enter current password',
      newPassword: 'New Password',
      newPasswordPh: 'Enter new password (min 6 chars)',
      confirmNewPassword: 'Confirm New Password',
      confirmNewPasswordPh: 'Re-enter new password',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      changeEmail: 'Change Email',
      currentEmail: 'Current Email',
      newEmail: 'New Email',
      newEmailPh: 'Enter new email',
      accountSecurity: 'Account Security',
      apiKey: 'API Key',
      notGenerated: 'Not generated'
    },
	chatSettings: {
	  title: 'Chat Settings',
	  avatar: 'Chat Avatar',
	  avatarTip: 'Recommended size: 200x200. Supports JPG/PNG. Max 5MB.',
	  channelName: 'Chat Name',
	  channelNamePlaceholder: 'Enter the display name for the chat',
	  welcomeMsg: 'Default Welcome Message',
	  welcomeMsgPlaceholder: 'Welcome message automatically sent when a visitor enters the chat',
	  save: 'Save Settings',
	  saving: 'Saving...',
	  saveSuccess: 'Saved successfully',
	  saveFailed: 'Failed to save'
	},
    chatPlan: {
      title: 'Chat Plans',
      currentPlan: 'Current Plan',
      perMonth: '/mo',
      seats: 'Agents',
      seatsUnit: '',
      maxSessions: 'Max Sessions',
      expiryTime: 'Expiry',
      daysLeft: '({0} days left)',
      autoRenew: 'Auto Renew',
      btnRenew: 'Renew Now',
      btnUpgrade: 'Upgrade',
      plansTitle: 'Plans',
      recommended: 'Recommended',
      current: 'Current',
      selectPlan: 'Select Plan',
      renewalTitle: 'Renewal History',
      thOrderId: 'Order ID',
      thPlan: 'Plan',
      thAmount: 'Amount',
      thPayment: 'Payment',
      thDuration: 'Duration',
      thExpiry: 'Expiry',
      thStatus: 'Status',
      renewModalTitle: 'Renew Plan',
      month: '{0} months',
      discount10: '10% OFF',
      discount7: '30% OFF',
      confirmRenew: 'Confirm Renew',
      renewSuccess: 'Renewed! Extended {0} months',
	  kaiqiok: 'Enabled successfully',
	  guanbiok: 'Disabled successfully',
      renewFailed: 'Renewal failed',
      retryLater: 'Please try again',
      switchSuccess: 'Switched to {0}',
      switchFailed: 'Switch failed'
    },
    chatManage: {
      sessionList: 'Sessions',
      sessionCount: '{0} sessions',
      searchVisitor: 'Search visitor...',
      online: 'Online',
      offline: 'Offline',
      source: 'Source:',
      btnTransfer: 'Transfer',
      btnEndSession: 'End Session',
      btnEnd: 'End',
      inputPlaceholder: 'Type a message...',
      send: 'Send',
      me: 'Me',
      selectSession: 'Select a session to start chat',
      emoji: 'Emoji',
      file: 'File',
      myChannel: 'My Chat Channel',
      wsOnline: 'WSS Connected',
      wsOffline: 'WSS Disconnected',
      chatLink: 'Chat Link',
      embedCode: 'Embed Code',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      noSessions: 'No sessions yet',
      sendImage: 'Send Image',
      recall: 'Recall'
    },
    receptionRecords: {
      title: 'Reception Records',
      allStatus: 'All Status',
      completed: 'Completed',
      ongoing: 'Ongoing',
      missed: 'Missed',
      searchVisitor: 'Search visitor name...',
      visitor: 'Visitor',
      source: 'Source',
      agent: 'Agent',
      startTime: 'Start Time',
      endTime: 'End Time',
      messages: 'Messages',
      satisfaction: 'Satisfaction',
      status: 'Status',
      action: 'Action',
      view: 'View',
      notRated: 'Not rated',
      totalRecords: '{0} records',
      prevPage: 'Previous',
      nextPage: 'Next',
      detailTitle: 'Session Detail',
      visitorEmail: 'Visitor Email:',
      sourceLabel: 'Source:',
      agentLabel: 'Agent:',
      durationLabel: 'Duration:',
      minute: 'min'
    },
    agentManage: {
      title: 'Agent Management',
      addAgent: 'Add Agent',
      agent: 'Agent',
      account: 'Account',
      status: 'Status',
      currentSessions: 'Active',
      lastOnline: 'Last Online',
      action: 'Action',
      online: 'Online',
      offline: 'Offline',
      enable: 'Enable',
      disable: 'Disable',
      edit: 'Edit',
      delete: 'Delete',
      loading: 'Loading...',
      empty: 'No agents yet, click Add in the top right',
      addTitle: 'Add Agent',
      editTitle: 'Edit Agent',
      nameLabel: 'Agent Name',
      namePlaceholder: 'e.g. Support Zhang',
      accountLabel: 'Login Account',
      accountPlaceholder: 'e.g. kefu1',
      passwordLabel: 'Login Password',
      passwordPlaceholder: 'At least 6 characters',
      resetPasswordLabel: 'Reset Password (leave blank to keep)',
      resetPasswordPlaceholder: 'Leave blank to keep the current password',
      statusLabel: 'Status',
      cancel: 'Cancel',
      saving: 'Saving...',
      save: 'Save',
      nameRequired: 'Please enter the agent name',
      passwordMin: 'Password must be at least 6 characters',
      accountRequired: 'Please enter the login account',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      opFailed: 'Operation failed',
      networkError: 'Network error, please try again later',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      toggleConfirm: 'Are you sure you want to {0} agent "{1}"?',
      deleteConfirm: 'Are you sure you want to delete agent "{0}"? This cannot be undone!'
    }
  },
  help: {
    title: 'Help Page',
    subtitle: 'Here you can find instructions on how to use SMS-Man services and answers to the most common questions',
    popularQuestions: 'Popular Questions',
    q1: 'How long to wait for SMS after registration?',
    q1a: 'SMS waiting time does not exceed 5 minutes. If you don\'t receive SMS within 5 minutes, cancel your number and buy another.',
    q2: 'How many SMS can I receive?',
    q3: 'What is the minimum recharge amount?',
    q4: 'If the service I need is not in the list, can I still receive SMS?',
    q5: 'SMS not received, what should I do?',
    q6: 'What does "Service temporarily unavailable" error mean?',
    q7: 'Where can I find my API key?',
    q8: 'How can you earn money with us?',
    serviceGuide: 'Service Guide',
    serviceGuideTitle: 'How do I register online?',
    serviceGuideDesc: 'Register an account, enter phone number, select country, select service, click buy, then wait for SMS.',
    howToRent: 'How to rent for my service?',
    howToRentDesc: 'Select service, select country, select rental period, click rent.',
    howToBuy: 'How to buy one-time SMS?',
    howToBuyDesc: 'Select service, select country, click buy SMS.',
    howToUseNumber: 'How to use my rented number?',
    howToUseNumberDesc: 'Copy the number from the order page, enter it on the target website, wait for SMS.',
    footer: {
      smsPlatform: 'SMS Platform',
      rentNumber: 'Rent Number',
      apiConnection: 'API',
      referral: 'Referral',
      partnership: 'Partnership',
      partners: 'Partners',
      blog: 'Share',
      help: 'Help',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      paymentRefund: 'Payment & Refund',
      companyInfo: 'VtoTop Company Limited',
      address: 'Room B, 10/F, Yue Cheong Building, 38 Des Voeux Road Central, Central, Hong Kong',
      email: 'vtoptopcom@gmail.com'
    }
  },
  blog: {
    title: 'Article Center',
    recentPosts: 'Recent Posts',
    archives: 'Archives',
    readMore: 'Read More',
    comments: 'Views',
    category: 'Category',
    currentCategory: 'Current Category:',
    clearFilter: '✕ Clear Filter',
    allCategories: 'All Categories',
    articleCategories: 'Categories'
  },
  articleDetail: {
    loading: 'Loading...',
    notFound: 'Article Not Found',
    backToList: '← Back to Articles',
    home: 'Home',
    blog: 'Share',
    views: 'views',
    share: 'Share:',
    relatedArticles: 'Related Articles'
  },
  homeApi: {
    title: 'For Developers',
    subtitle: 'This section is the API documentation for connecting your services with SMS-Man and automated number purchasing.',
    legacyApi: 'Legacy API',
    apiV2: 'API 2.0',
    miniApi: 'Mini API',
    apiDesc: 'The API interface allows you to automatically purchase and receive SMS from SMS-Man. Services are automatically synchronized. To make your system automatically receive, reset API. To use the API, you also need your API key. You can view it by entering the profile page. All our API requests are via GET or POST methods. All requests must include the token parameter and API key.',
    getBalance: 'Get Balance',
    getBalanceDesc: 'Get current account balance',
    params: 'Parameters',
    field: 'Field',
    type: 'Type',
    required: 'Required',
    value: 'Value',
    result: 'Result',
    possibleErrors: 'Possible Errors',
    rateLimit: 'Rate Limit',
    getNumber: 'Get Number',
    getNumberDesc: 'Get a number for the specified country, provide country_id',
    getSms: 'Get SMS',
    getSmsDesc: 'Get SMS for the specified order',
    setStatus: 'Set Status',
    setStatusDesc: 'Change order status',
    getCountries: 'Get Countries List',
    getCountriesDesc: 'Get all available countries',
    getServices: 'Get Services List',
    getServicesDesc: 'Get all available services'
  },
  onlineSms: {
    hero: {
      title: 'Online SMS Verification Platform',
      desc: 'Register on social networks, online stores, exchanges and online services without receiving spam or exposing personal data.',
      viewNumbers: 'View Numbers',
      receiveCode: 'Receive Code'
    },
    countries: {
      title: 'Choose Country/Region',
      subtitle: 'Choose from 200+ countries to get a virtual number for SMS verification',
      services: 'services',
      select: 'Select'
    },
    services: {
      title: 'Most Popular Services Today',
      buy: 'Buy'
    },
    howItWorks: {
      title: 'Rent a Virtual Number in 3 Steps',
      subtitle: 'See how it works',
      step1Title: 'Choose Country',
      step1Desc: 'Select the country for your virtual number from 200+ options',
      step2Title: 'Choose Service',
      step2Desc: 'Select the app or service you need to receive SMS from',
      step3Title: 'Receive SMS',
      step3Desc: 'Get a virtual number and receive verification codes online'
    },
    features: {
      fastTitle: 'Fast Verification',
      fastDesc: 'Get verification codes in seconds, no waiting',
      safeTitle: 'Privacy Protection',
      safeDesc: 'Use virtual numbers to protect your personal privacy',
      globalTitle: 'Global Coverage',
      globalDesc: 'Support services in 200+ countries'
    },
    cta: {
      title: 'Register Now and Start Verifying',
      desc: 'Get free credits upon registration and experience our virtual number service',
      register: 'Register Free'
    },
    faq: {
      title: 'FAQ',
      q1: 'What is online SMS verification?',
      a1: 'Online SMS verification is a service that uses virtual numbers to receive SMS verification codes without using your real phone number.',
      q2: 'How long can I use a number?',
      a2: 'Depending on the service, numbers can be used from 20 minutes to 30 days.',
      q3: 'How is privacy protected?',
      a3: 'All numbers are virtual and destroyed after use, never exposing your real phone number.'
    }
  },
  esim: {
    hero: {
      title: 'Buy eSIM Online',
      desc: 'Get global mobile data instantly. Activate your eSIM via QR code in seconds and say goodbye to expensive roaming fees.',
      learnMore: 'Learn More',
      countries: 'Countries',
      network: 'Network',
      activation: 'Activation'
    },
    howItWorks: {
      title: 'Connected in Three Easy Steps',
      step1Title: 'Choose Your Plan',
      step1Desc: 'Select the country/region and data plan you need',
      step2Title: 'Pay & Get QR Code',
      step2Desc: 'After payment, you will receive an eSIM activation QR code',
      step3Title: 'Scan & Go Online',
      step3Desc: 'Scan the QR code in your phone settings to activate eSIM'
    },
    whyEsim: {
      title: 'Why eSIM',
      subtitle: 'A smarter way to stay connected abroad',
      f1Title: 'No Roaming Fees',
      f1Desc: 'Use local mobile networks and avoid expensive international roaming charges',
      f2Title: 'Instant Activation',
      f2Desc: 'Activate by scanning QR code, no waiting for physical SIM card',
      f3Title: 'Keep Your Main SIM',
      f3Desc: 'Continue using your main number while using eSIM for data'
    },
    cta: {
      title: 'Ready to Travel Without Roaming Fees?',
      desc: 'Activate your eSIM in minutes and stay connected worldwide'
    },
    comparison: {
      title: 'eSIM vs. a Local SIM Card',
      r1: 'Set up before travel',
      r2: 'Instant activation',
      r3: 'No card swapping',
      r4: 'Keep your main number',
      r5: 'Fixed, predictable price',
      r6: 'Email-only sign-up',
      r7: 'Crypto accepted'
    },
    plus: {
      title: 'eSIM, Plus Everything SMS-MAN Already Does',
      desc: 'Pair your data plan with virtual numbers and SMS verification — all under one account'
    },
    faq: {
      title: 'Questions About eSIM',
      q1: 'What is an eSIM and how does it work?',
      a1: 'An eSIM is an embedded SIM card that activates mobile data without a physical card. Simply scan a QR code to activate.',
      q2: 'Which devices support SMS-MAN eSIM?',
      a2: 'Most modern smartphones support eSIM, including iPhone XS and later, Samsung Galaxy S20 and later.',
      q3: 'How fast is activation?',
      a3: 'Usually just seconds — scan the QR code and you are ready to go.',
      q4: 'Will my eSIM replace my main number?',
      a4: 'No, eSIM is for data only. Your main number stays the same.',
      q5: 'Can I top up or buy more data later?',
      a5: 'Yes, you can purchase additional data packs anytime from your account.'
    }
  },
  agent: {
    hero: {
      title: 'Become an SMS-MAN Agent',
      desc: 'Earn commissions by promoting SMS-MAN services and build your passive income stream.',
      becomeAgent: 'Become an Agent',
      learnMore: 'Learn More'
    },
    benefits: {
      title: 'Agent Benefits',
      subtitle: 'Why become an SMS-MAN agent',
      b1Title: 'High Commission',
      b1Desc: 'Earn up to 20% referral commission',
      b2Title: 'Passive Income',
      b2Desc: 'Earn commissions as long as your referrals keep spending',
      b3Title: 'Dedicated Support',
      b3Desc: 'Exclusive agent account manager for fast issue resolution',
      b4Title: 'Global Market',
      b4Desc: 'Promote to users worldwide with no geographic restrictions'
    },
    howItWorks: {
      title: 'How to Get Started',
      step1Title: 'Register Account',
      step1Desc: 'Create an SMS-MAN account and apply to become an agent',
      step2Title: 'Get Referral Link',
      step2Desc: 'Receive your unique referral link and marketing materials',
      step3Title: 'Earn Commission',
      step3Desc: 'Earn commission when users register and spend through your link'
    },
    commission: {
      title: 'Commission Levels',
      l1Name: 'Junior Agent',
      l1Desc: '1-50 referred users per month',
      l2Name: 'Mid Agent',
      l2Desc: '51-200 referred users per month',
      l3Name: 'Senior Agent',
      l3Desc: '200+ referred users per month'
    },
    features: {
      title: 'Agent Tools',
      f1Title: 'Dashboard',
      f1Desc: 'Real-time view of referral data and commission earnings',
      f2Title: 'Referral Link',
      f2Desc: 'Unique referral link with precise conversion tracking',
      f3Title: 'Fast Withdrawal',
      f3Desc: 'Withdraw commissions anytime to multiple payment methods',
      f4Title: 'Dedicated Support',
      f4Desc: 'Exclusive agent support channel with priority handling'
    },
    cta: {
      title: 'Ready to Get Started?',
      desc: 'Register now to become an SMS-MAN agent and start your passive income journey',
      joinNow: 'Join Now'
    }
  },
  softwareDev: {
    heroTitle: 'Professional Software Development Services',
    heroDesc: 'From requirements analysis to delivery, we provide full-stack custom development solutions. Covering web applications, mobile apps, management systems, API development, and more.',
    btnViewCases: 'View Cases',
    btnContact: 'Contact Us',
    servicesTitle: 'Services',
    servicesSubtitle: 'Providing comprehensive software development services to meet diverse business needs',
    service1Title: 'Web Application Development',
    service1Desc: 'Full-stack development for corporate websites, e-commerce platforms, SaaS systems, and admin dashboards',
    service2Title: 'Mobile App Development',
    service2Desc: 'Native iOS/Android apps and cross-platform development with React Native/Flutter',
    service3Title: 'API Development',
    service3Desc: 'RESTful APIs, WebSocket real-time communication, and third-party system integration',
    service4Title: 'Automation Systems',
    service4Desc: 'Data collection, automation scripts, scheduled tasks, and business process automation',
    service5Title: 'Gaming/Entertainment Systems',
    service5Desc: 'Card games, lottery systems, instant messaging, and real-time interactive platforms',
    service6Title: 'Cloud Deployment',
    service6Desc: 'Server deployment, CI/CD pipelines, Docker containerization, and performance optimization',
    techStackTitle: 'Tech Stack',
    casesTitle: 'Project Cases',
    casesSubtitle: 'Showcase of delivered projects',
    projectShare: 'Share',
    processTitle: 'Development Process',
    process1Title: 'Requirements Discussion',
    process1Desc: 'Deep understanding of project requirements, defining scope and technical approach',
    process2Title: 'Solution Design',
    process2Desc: 'Detailed technical architecture, database design, and UI prototypes',
    process3Title: 'Development',
    process3Desc: 'Agile development with regular demos and progress communication',
    process4Title: 'Testing & Optimization',
    process4Desc: 'Comprehensive functional, performance, and security testing',
    process5Title: 'Deployment',
    process5Desc: 'Server deployment, domain configuration, SSL certificates, and monitoring',
    process6Title: 'Maintenance & Support',
    process6Desc: 'Ongoing technical support and bug fixes to ensure system stability',
    stats1Label: 'Projects Delivered',
    stats2Label: 'Happy Clients',
    stats3Label: 'Years Experience',
    stats4Label: 'Client Satisfaction',
    contactTitle: 'Have a Project in Mind?',
    contactDesc: 'Tell us your ideas, and we will provide professional development solutions and quotes',
    contactOnline: 'Online Support',
    contactBtn: 'Consult Now'
  },
  lotteryPage: {
    heroTitle: 'Live Lottery Draw Center',
    heroDesc: 'Multi-lottery instant draws, real-time data sync, fair and transparent',
    statLottery: 'Lottery Types',
    statNonStop: 'Non-stop Draws',
    statSync: 'Real-time Sync',
    periodDraw: 'Draw #{0}',
    currentRemain: 'Current {0}, Remaining {1}',
    dragonTiger: '1-5 Dragon/Tiger',
    championSum: 'Champion Sum',
    betNow: 'Bet Now',
    tabHistory: 'History',
    tabRoad: 'Road Analysis',
    tabHotCold: 'Hot/Cold',
    tabTrend: 'Champion Trend',
    rulesTitle: 'Rules',
    rule1Title: 'Dragon/Tiger',
    rule1Desc: 'Compare the first and last drawn numbers. First is Dragon, last is Tiger.',
    rule2Title: 'Champion Sum',
    rule2Desc: 'Add champion and runner-up numbers, determine big/small and odd/even by the sum.',
    rule3Title: 'Big/Small Odd/Even',
    rule3Desc: 'Determine big (6-10) or small (1-5) and odd/even based on position or sum.',
    rule4Title: 'Road Analysis',
    rule4Desc: 'Analyze draw patterns and trends through historical road map charts.',
    dragon: 'Dragon',
    tiger: 'Tiger',
    big: 'Big',
    small: 'Small',
    odd: 'Odd',
    even: 'Even',
    countdownMin: 'min',
    countdownSec: 'sec',
    nameSpeedRacing: 'Speed Racing',
    nameSgAirship: 'SG Airship',
    nameSpeedAirship: 'Speed Airship',
    nameLuckyAirship: 'Lucky Airship',
    logoRacing: 'Racing',
    logoAirship: 'Airship'
  },
  apiDocs: {
    pageTitle: 'API Documentation',
    pageSubtitle: 'Providing SMS, lottery draw, customer service and other API interfaces for rapid integration',
    tabSms: 'SMS API',
    tabLottery: 'Lottery API',
    tabChat: 'Live Chat API',
    versionLegacy: 'Legacy API',
    versionV2: 'API 2.0',
    versionMini: 'Mini API',
    baseAddress: 'Base URL',
    requestMethod: 'Method',
    returnFormat: 'Response Format',
    authMethod: 'Authentication',
    requestParams: 'Request Parameters',
    field: 'Field',
    type: 'Type',
    required: 'Required',
    description: 'Description',
    yes: 'Yes',
    no: 'No',
    returnExample: 'Response Example',
    smsDesc: 'SMS API provides complete features for virtual number acquisition, SMS receiving, status management, supporting 200+ countries.',
    lotteryDesc: 'Lottery API provides real-time draw data queries, historical records, trend analysis, supporting multiple lottery types.',
    chatDesc: 'Live Chat API provides session management, messaging, agent management, supporting WebSocket real-time communication and RESTful interfaces.',
    ep: {
      getBalance: 'Get Balance', getNumber: 'Get Number', getSms: 'Get SMS',
      checkBalance: 'Check Balance', createOrder: 'Create Order', querySms: 'Query SMS',
      setStatus: 'Set Status', getCountries: 'Get Countries', getServices: 'Get Services',
      getLotteryList: 'Get Draw List', getLotteryHistory: 'Get Draw History',
      getLotteryTypes: 'Get Lottery Types', liveDraw: 'Live Draw',
      lotteryHistory: 'Draw History', lotteryStats: 'Draw Statistics',
      latestDraw: 'Latest Draw', createSession: 'Create Session',
      sendMessage: 'Send Message', getMessageHistory: 'Get Message History',
      agentStatus: 'Agent Status', closeSession: 'Close Session', quickSend: 'Quick Send'
    },
    epd: {
      getBalance: 'Query current account balance', getNumber: 'Get a virtual number for receiving SMS',
      getSms: 'Get SMS verification code for a number', checkBalance: 'Get current available balance',
      createOrder: 'Create SMS order and get virtual number', querySms: 'Poll to get order SMS content',
      setStatus: 'Set order status (received/cancel/continue)',
      getCountries: 'Get all supported countries', getServices: 'Get all supported SMS services',
      getLotteryList: 'Get latest draw info for all lotteries', getLotteryHistory: 'Get draw history for a lottery type',
      getLotteryTypes: 'Get all supported lottery types', liveDraw: 'Get latest draw result for a lottery',
      lotteryHistory: 'Get draw history with pagination', lotteryStats: 'Get draw statistics (hot/cold numbers, missing values)',
      latestDraw: 'Get latest draw for all lotteries (simplified)', createSession: 'Create a new support session',
      sendMessage: 'Send a message to a session', getMessageHistory: 'Get chat history of a session',
      agentStatus: 'Get online agent list and status', closeSession: 'Close a specific session',
      quickSend: 'Create session and send message in one call',
      getNumberSimple: 'Get number in one click (simplified)', getSmsSimple: 'Get SMS content',
      createSessionV2: 'Create support session with auto agent assignment', sendMessageV2: 'Send message to a specific session'
    }
  },
  liveChat: {
    heroTitle: 'Live Chat System',
    heroDesc: 'WebSocket-based real-time customer service chat platform, supporting multi-agent collaboration, smart routing, message history, file transfer, providing 24/7 instant service for your customers.',
    btnFreeTrial: 'Free Trial',
    btnDemo: 'Download Desktop Client',
    previewName: 'Agent Wang',
	catedengl: 'Customer Service Login',
    previewStatus: '● Online',
    previewMsg1: 'Hello! How can I help you?',
    previewMsg2: 'I would like to know about your services',
    previewMsg3: 'Sure, let me introduce it to you...',
    inputPlaceholder: 'Type a message...',
    featuresTitle: 'Core Features',
    featuresSubtitle: 'Comprehensive customer service solution to improve satisfaction',
    feature1Title: 'Real-time Messaging',
    feature1Desc: 'WebSocket-based millisecond message delivery for smooth conversations',
    feature2Title: 'Multi-agent Collaboration',
    feature2Desc: 'Multiple agents online simultaneously with smart session routing',
    feature3Title: 'Message History',
    feature3Desc: 'Complete chat history with search and export for training and reference',
    feature4Title: 'File Transfer',
    feature4Desc: 'Send and receive images, documents and other file types',
    feature5Title: 'Smart Routing',
    feature5Desc: 'Auto-assign customers based on agent load and skill tags',
    feature6Title: 'Analytics & Reports',
    feature6Desc: 'Real-time statistics on sessions, response time, satisfaction and more',
    stepsTitle: 'Quick Setup',
    step1Title: 'Register Account',
    step1Desc: 'Create admin account, configure company info and support team',
    step2Title: 'Embed Code',
    step2Desc: 'Embed one line of code on your website to show the chat widget',
    step3Title: 'Start Service',
    step3Desc: 'Agents log in and start receiving and replying to customers',
    dashboardTitle: 'Powerful Admin Panel',
    dashboardDesc: 'Real-time monitoring of agent status, session data, customer satisfaction',
    dashFeature1: 'Real-time agent status and session count',
    dashFeature2: 'Session routing rules and auto-assignment',
    dashFeature3: 'Agent working hours and performance stats',
    dashFeature4: 'Customer satisfaction ratings and feedback',
    dashFeature5: 'Chat history search and export',
    dashFeature6: 'Custom quick replies and knowledge base',
    dashStat1: "Today's Sessions",
    dashStat2: 'Satisfaction',
    dashStat3: 'Avg Response',
    dashStat4: 'Online Agents',
    pricingTitle: 'Pricing Plans',
    pricingBadge: 'Recommended',
    pricingPeriod: '/mo',
    btnSelectPlan: 'Select Plan',
    planBasic: 'Basic',
    planPro: 'Professional',
    planEnterprise: 'Enterprise',
    ctaTitle: 'Ready to improve your customer service?',
    ctaDesc: 'Register now and try all features for free',
    ctaBtn: 'Get Started Free',
    pf1Basic: '1 Agents', pf2Realtime: 'Real-time Chat', pf3History: 'Message History',
    pf4Reports: 'Basic Reports', pf5Email: 'Email Support',
    pf1Agents: '10 Agents', pf4AdvReports: 'Advanced Reports', pf5Smart: 'Smart Routing',
    pf6File: 'File Transfer', pf7Priority: 'Priority Support',
    ef1Unlimited: 'Unlimited Agents', ef2All: 'All Features', ef3Api: 'API Access',
    ef4Private: 'Private Deployment', ef5Dedicated: 'Dedicated Support', ef6Sla: 'SLA Guarantee'
  },
  apiMsg: {
    userNotFound: 'This email is not registered', wrongPassword: 'Incorrect password', accountDisabled: 'This account has been disabled',
    agentNotFound: 'Agent account does not exist', agentDisabled: 'This agent account has been disabled',
    notLogin: 'Please sign in first', tokenExpired: 'Your session has expired, please sign in again',
    emailRequired: 'Please enter your email', emailInvalid: 'Invalid email format',
    emailPasswordRequired: 'Email and password are required', accountPasswordRequired: 'Account and password are required',
    agentAccountRequired: 'Agent account and password are required',
    passwordMin: 'Password must be at least 6 characters', newPasswordMin: 'New password must be at least 6 characters',
    emailExists: 'This email is already registered', usernameExists: 'This username is already taken',
    captchaWrong: 'Incorrect verification code', captchaExpired: 'Verification code expired, please request a new one',
    paramError: 'Invalid parameters', paramIncomplete: 'Please complete all required fields', missingId: 'Missing ID',
    nothingToUpdate: 'There is nothing to update', invalidStatus: 'Invalid status value', indexOutOfRange: 'Index out of range',
    missingChannelCode: 'Channel code is missing', channelNotFound: 'Channel not found', channelClosed: 'This channel is closed',
    noChatChannel: 'This member has not enabled a support channel', chatPlanExpired: 'The support plan has expired and is unavailable',
    noAgentOnlineRetry: 'No agent is online right now, please try again later',
    targetAgentInvalid: 'Target agent does not exist or is disabled', agentNoOperate: 'Agent does not exist or you have no permission',
    sessionNotFound: 'Session not found', sessionMismatch: 'Session mismatch',
    noPermissionTransfer: 'You are not allowed to transfer this session', noPermissionClose: 'You are not allowed to close this session',
    noPermissionDelete: 'You are not allowed to delete this session',
    chatHasHistory: 'This session has chat history and cannot be deleted', clientOnline: 'The customer is online, deletion is not allowed',
    onlyAgentRecall: 'Only agent messages can be recalled',
    balanceInsufficient: 'Insufficient balance', rechargeMinAmount: 'The minimum top-up amount is 1 USD',
    orderNotFound: 'Order not found', orderCancelled: 'This order has been cancelled', orderConfirmed: 'This payment has already been confirmed',
    orderNotPayable: 'This order status does not allow the operation',
    planNotFound: 'Plan not found', serviceNotFound: 'Service not found', articleNotFound: 'Article not found',
    numberUnavailable: 'This number is unavailable', noAvailableNumber: 'No number available',
    numberExists: 'This number already exists', rentalNotFound: 'Rental record not found',
    agentLimitReached: 'The agent limit of your plan has been reached', emailSendFailed: 'Failed to send email, please try again later'
  },
  clientDownload: {
    badge: 'Official Desktop App',
    heroTitle: 'Customer Service Client',
    heroDesc: 'A desktop client built for support agents, with multi-session handling, real-time message push, quick replies and agent transfer to help your team serve every customer efficiently.',
    winDownload: 'Download for Windows',
    winHint: 'Windows 10 / 11',
    macDownload: 'Download for macOS',
    macHint: 'macOS 10.15 or later',
    previewAlt: 'Customer service client preview',
    notice: 'Download, unzip and run — no installation required. If your system warns about an unidentified developer, allow it in System Settings.',
    featuresTitle: 'Key Features',
    featuresSubtitle: 'A desktop tool designed for high-volume support, more stable and efficient than the web version',
    f1Title: 'Multi-session Management',
    f1Desc: 'The session list updates in real time with unread highlights, so no customer is missed.',
    f2Title: 'Real-time Messages',
    f2Desc: 'Built on a persistent WebSocket connection with millisecond delivery and automatic reconnection.',
    f3Title: 'Quick Replies',
    f3Desc: 'Send common responses in one click to cut repetitive typing and boost response speed.',
    f4Title: 'Transfer & Collaboration',
    f4Desc: 'Transfer sessions to another agent and handle complex issues as a team.',
    stepsTitle: 'Get Started in 3 Steps',
    s1Title: 'Download & Unzip',
    s1Desc: 'Choose the Windows or macOS build for your system, download and unzip to run.',
    s2Title: 'Sign in as Agent',
    s2Desc: 'Log in with the agent account created in the member center; sessions sync automatically.',
    s3Title: 'Start Serving',
    s3Desc: 'Visitor messages arrive in real time; use quick replies and transfers to help them fast.',
    ctaTitle: 'No agent account yet?',
    ctaDesc: 'Go to the member center to create an agent account and start serving customers today.',
    ctaBtn: 'Go to Member Center'
  },
  visitorChat: {
    noAgentOnline: 'No agent is online right now. Your messages will be answered once an agent comes online.',
    online: 'Online',
    offline: 'Offline',
    connecting: 'Connecting...',
    defaultTitle: 'Live Support',
    defaultWelcome: 'Hello! Welcome to our support system. How can we help you?',
    channelNotFound: 'Channel not found or closed',
    loadError: 'Failed to load, please try again later',
    imageTooLarge: 'Image size cannot exceed 2MB',
    sendImage: 'Send Image',
    inputPlaceholder: 'Type a message...',
    supportSuffix: 'Support'
  }
}
